import HindBold from '../data/fonts/Hind-Bold.ttf'
import HindLight from '../data/fonts/Hind-Light.ttf'
import HindRegular from '../data/fonts/Hind-Regular.ttf'

export default {
  HindBold,
  HindLight,
  HindRegular,
}
